const t = "_textArea_7j5p4_1", e = "_textFilled_7j5p4_4", l = {
  textArea: t,
  textFilled: e
};
export {
  l as default,
  t as textArea,
  e as textFilled
};
//# sourceMappingURL=styles.module.scss.js.map
